module.exports = __webpack_public_path__ + "static/media/wmsui32_2224.eb945f06.ico";